import { render, staticRenderFns } from "./TaggingsList.vue?vue&type=template&id=f6ed7a20&scoped=true&"
import script from "./TaggingsList.vue?vue&type=script&lang=js&"
export * from "./TaggingsList.vue?vue&type=script&lang=js&"
import style0 from "./TaggingsList.vue?vue&type=style&index=0&id=f6ed7a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed7a20",
  null
  
)

export default component.exports